import { Box } from '@mui/material';

import { defendantsAccountTabs } from '../../constants/tabRoutes';

import TabsPanel from '../../components/TabsPanel';
import { useHasPermission } from '../../hooks/useHasPermission';

const DefendantAccountView = () => {
  const canViewCases = useHasPermission('Cases', 'View');

  const tabs = defendantsAccountTabs.filter(
    (tab) => tab.path !== 'cases' || canViewCases,
  );

  return (
    <>
      <Box display="flex" width="100%">
        <TabsPanel tabsList={tabs} locationSlicePosition={3} />
      </Box>
    </>
  );
};

export default DefendantAccountView;
